

import * as React from "react";
// import { PanelContainer } from "../Components/PanelContainer";
import DataTableTemplate from "../../Cpanel/Components/DataTableTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { fetchData, getFilterButton, getFilterClearButton, getFilterDate } from "../../Cpanel/Components/Utilities";
import { Button, Table } from "react-bootstrap";
import DatePickerFormat from "../../Landing/Components/FormOptions/DatePickerFormat";
import { useForm } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { MainLayout } from "../Components/MainLayout";
import Helmet from "../Components/Helment";
import { useNavigate } from "react-router-dom";

 const ShopList = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [pageData, setPageData] = useState([]);
  const [shopItemData, setShopItemData] = useState([]);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      date: { value: "", matchMode: "contains" },
    },
    sortField: "date",
    sortOrder: 1,
  });
  const navigate = useNavigate()
  useEffect(() => {
    fetchDataFromAPI();
  }, [lazyState]);

  console.log(lazyState);
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const fetchDataFromAPI = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState.rows ?? 20);
    if (lazyState.sortField && lazyState.sortOrder) {
      if (lazyState.sortField === "date") {
        bodyFormData.append(
          "sort",
          lazyState.sortOrder === 1 ? "date-A" : "date-d"
        );
      }
      if (lazyState.sortField === "cashback") {
        bodyFormData.append("cashback", lazyState.sortOrder === 1 ? "A" : "d");
      }
    }
    try {
      const { from, to } = JSON.parse(lazyState.filters.date.value);
      if (from && to) {
        bodyFormData.append("date", `${new Date(from)}|${new Date(to)}`);
      }
    } catch {}
    fetchData("allbasket", bodyFormData, handleApiResponse);
  };
  const handleSort = (event) => {
    console.log(event);
    const { sortField, sortOrder } = event;
    console.log(sortField, sortOrder);
    setLazyState((prevState) => ({
      ...prevState,
      sortField: sortField,
      sortOrder: sortOrder,
    }));
  };
  const handleApiResponse = (data) => {
    setPageData(data?.data);
    setTotalRecords(data?.count);
  };
  // const getFilterButton = (option) => (
  //   <Button onClick={() => option.filterApplyCallback(option.filterModal)}>
  //     اعمال
  //   </Button>
  // );
  // const getFilterInputText = (options, placeholder) => (
  //   <div>
  //     <DatePickerFormat
  //       name={"from"}
  //       label={"از تاریخ:"}
  //       control={control}
  //       onChange={(date) =>
  //         options.filterCallback(
  //           JSON.stringify({ from: date, to: watch("to") })
  //         )
  //       }
  //     />
  //     <DatePickerFormat
  //       name={"to"}
  //       label={"تا تاریخ:"}
  //       control={control}
  //       onChange={(date) =>
  //         options.filterCallback(
  //           JSON.stringify({ from: watch("from"), to: date })
  //         )
  //       }
  //     />
  //   </div>
  // );

  // const getFilterClearButton = (options) => (
  //   <Button
  //     type="button"
  //     icon="pi pi-times"
  //     className="btn btn-danger"
  //     onClick={options.filterClearCallback}
  //     severity="secondary"
  //   >
  //     حذف فیلتر
  //   </Button>
  // );
  const cols = [
    {
      field: "",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "basketid",
      header: "شناسه سبد خرید",
    },
    {
      field: "username",
      header: "نام خریدار",
      body: (data, options) => data?.username?.split("|")[0],
    },
    {
      field: "date",
      header: "تاریخ ",
      sortable: true,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        // getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
        getFilterDate(options, '', watch, control),
      filterClear: getFilterClearButton,
    },
    {
      field: "cashback",
      header: "کش بک",
      sortable: true,
    },
    {
      field: "shopname",
      header: "فروشگاه",
      body: (data, options) => data?.shopname?.split("|")[0],
    },
    { field: "description", header: "توضیحات" },
    {
      field: "basketid",
      header: "جزئیات",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data?.basketid)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
        </div>
      ),
    },
  ];
  const handleOpeEditItem = (data) => {
    setShowEditComponent(true);
    const bodyFormData = new FormData();
    bodyFormData.append("taab30basketid", data);
    fetchData("getbasketitem", bodyFormData, handleShopItemApiResponse);
    console.log(data);
  };

  const handleShopItemApiResponse = (data) => {
    setShopItemData(data?.data);
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
  };
  const header = <div>{/* <DatePickerFormat control={}/> */}</div>;
  return (
    <div className="container">
       <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2 mb-2 "
        onClick={()=> navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      {/* <PanelContainer title={"خریدها"}> */}

      <div className="card  wm-100 m-auto container">
        <div className="card-body">
          <h5 className="card-title text-center">
            <span className="text-warning">
              <FontAwesomeIcon icon="shopping-bag" className="header-icon fs4" />
            </span>{" "}
            خرید های های من
          </h5>
        </div>
        <DataTableTemplate
          sortOrder={lazyState.sortOrder}
          sortField={lazyState.sortField}
          onSort={handleSort}
          lazyState={lazyState}
          // header={header}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          filters={lazyState.filters}
          onFilter={onFilter}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
          header={header}
        />
        </div>
      {/* </PanelContainer> */}
      {showEditComponent && (
        <>
          <div className="container panel p-2 m-3 mainElement_shopping">
            <h5>جزئیات سبد خرید</h5>
            <p>
              <strong>نام خریدار:</strong> {shopItemData?.userName}
            </p>
            <p>
              <strong></strong> {shopItemData?.userEmail}
            </p>
            <p>
              <strong>فروشگاه:</strong> {shopItemData?.shopName}
            </p>

            <h3>سبد خرید</h3>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th className="profileMainTitle">#</th>
                  <th className="profileMainTitle">نام</th>
                  <th>تعداد</th>
                  <th>قیمت</th>
                  <th>جمع</th>
                </tr>
              </thead>
              <tbody>
                {shopItemData?.basketItems?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                    <td>${item.price}</td>
                    <td>${item.quantity * item.price}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
    </div>
  );
};

export default () => (
  <Helmet title="خرید های من">
    {" "}
    <MainLayout children={<ShopList />} />
  </Helmet>
);
